export default __webpack_public_path__ + "static/media/Linkedin.c92b5bb7.png";